



























import { Vue, Component, Prop } from 'vue-property-decorator';
import { IBankId } from '@signing-page/signing/types/bankid';
import { SigningHelper } from '@signing-page/signing/helpers/signing.helper';
import { EBankIdStep } from '@signing-page/signing/types/enums/bankid-se';

@Component({
  data: () => ({
    EBankIdStep,
  }),
})
export default class BankIdSameDevice extends Vue {
  @Prop() bankId!: IBankId;
  @Prop() jwt!: string;

  get bankIdAutoStartUrl(): string {
    const baseUrl = 'bankid:///?autostarttoken=';
    if (SigningHelper.isIOS()) {
      const redirectUrl: string = SigningHelper.getBankIDiOSRedirectUrl(this.bankId, this.jwt);
      return `${baseUrl}${this.bankId.autoStartToken}&redirect=${encodeURIComponent(redirectUrl)}`;
    }
    return `${baseUrl}${this.bankId.autoStartToken}&redirect=null`;
  }

  handleCancel(): void {
    this.$emit('cancel');
  }
}
